// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"ebdf2713","205":"41a9f8bf"}[chunkId] + ".chunk.css";
};